// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Collapse = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path fill="currentColor" d="M3.5 9.5h5v1h-5zM9.5 7.5h5v1h-5z" />
    <path fill="currentColor" d="M7.5 14.5v-5h1v5zM9.5 8.5v-5h1v5z" />
    <path stroke="currentColor" d="m8 10-6 6M16 2l-6 6" />
  </svg>
);
const ForwardRef = forwardRef(Collapse);
export default ForwardRef;
